import lodash from 'lodash'
export default {
  getListTag (state, payload) {
    state.tags = payload.data
    state.last_page = payload.meta ? payload.meta.last_page : 0
    state.total = payload.meta ? payload.meta.total : 0
  },
  createTag (state, payload) {
    state.tags.push(payload)
    state.total += 1
  },
  destroyTag (state, payload) {
    var index = lodash.findIndex(state.tags, ['id', payload.id])
    state.tags.splice(index, 1)
    state.total -= 1
  },
  updateTag (state, payload) {
    var index = lodash.findIndex(state.tags, ['id', payload.id])
    state.tags.splice(index, 1, payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/module/tag/mutations.js